import React from 'react'
import { Col } from 'antd'
import styled from 'styled-components'
import { TableRow } from 'Components/Shared/Table'
import { EditIcon, TrashIcon } from 'Components/Shared/Icon'
import { FloorPlan } from 'features/admin/floorPlan/types'

type DefaultProps = {
  item: any
  selected?: boolean
  onClick: (item: FloorPlan) => void
  onDelete: (item: FloorPlan) => void
}

type Props = DefaultProps

const RowItem: React.FC<Props> = props => {
  const { item, selected } = props

  const onClick = () => props.onClick(item)
  const onDelete = () => props.onDelete(item)

  const isUsed = item.Status.toLocaleLowerCase() === 'used'
  const Status = isUsed ? (
    <RedText>มีการใช้งานแล้ว</RedText>
  ) : (
      <GreenText>แก้ไขได้</GreenText>
    )

  const img = item.ImageFloorPlan && item.ImageFloorPlan.FileUrl

  return (
    <RowModel>
      <TableRow
        selected={selected}
        minHeight={60}
        spaceBetweenRow={8}
        paddingLeft={24}
      >
        <Col span={12}>
          <Name onClick={onClick}>
            {img ? (
              <img className="img" src={img} alt="" />
            ) : (
                <div className="img" />
              )}
            {item.FloorPlanName}
          </Name>
        </Col>
        <Col span={4}>{item.UsedCounter}</Col>
        <Col span={4}>{Status}</Col>
        <Col span={4}>
          <Icon onClick={onClick}>
            <EditIcon size={20} color="#8b99a7" />
          </Icon>
          {!isUsed && (
            <Icon onClick={onDelete}>
              <TrashIcon size={20} color="#8b99a7" />
            </Icon>
          )}
        </Col>
      </TableRow>
    </RowModel>
  )
}

const RowModel = styled.div`
  cursor: pointer;
`

const Name = styled.div`
  font-family: 'DB Helvethaica X 75 Bd';
  color: #000;
  display: flex;
  align-items: center;
  .img {
    height: 40px;
    width: 40px;
    margin-right: 22px;
  }
`
const Icon = styled.div`
  float: left;
  margin-right: 20px;
  margin-top: 5px;
  cursor: pointer;
`

const GreenText = styled.div`
  color: #5bc79e;
`

const RedText = styled.div`
  color: #d0494c;
`

export default RowItem
